PopOver = require 'app/scripts/views/lib/pop-over'
SetCardLocationPopoverView = require 'app/scripts/views/map/set-card-location-popover-view'
t = require('app/scripts/views/internal/teacup-with-helpers')('card_location')
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
{ Noun, Verb, trackUe } = require '@trello/analytics'
{ formatLatLng } = require 'app/common/lib/util/format-coordinates'

template = t.renderable ->
  t.ul '.pop-over-list', ->
    t.li ->
      t.a '.js-change-location', { href: '#' }, ->
        t.format 'change-location'
    t.li ->
      t.a '.js-delete-location', { href: '#' }, ->
        t.format 'remove'

deleteLocationTemplate = t.renderable ->
  t.div ->
    t.p ->
      t.format 'removing-a-location-is-permanent-there-is-no-undo'
    t.div ->
      t.button '.full.negate.js-delete-location', ->
        t.format 'remove'

class CardLocationDeleteView extends View

  viewTitleKey: 'remove location'

  events:
    'click .js-delete-location': 'deleteLocation'

  deleteLocation: (e) ->
    Util.stop(e)

    trackUe(Noun.CARD_BACK, Verb.DELETES, 'location coordinates', '', '', 'by clicking on the location overflow menu item', {
      idCard: @model.id
      idList: @model.getList().id
      idBoard: @model.getBoard().id
    })

    @model.removeLocation()

    PopOver.hide()

  render: ->
    @$el.html deleteLocationTemplate()

    @

module.exports = class CardLocationMenuPopoverView extends View

  events:
    'click .js-change-location': 'changeLocation'
    'click .js-delete-location': 'deleteLocation'

  getViewTitle: ->
    title = @model.get('locationName') || @model.get('address')

    if !title
      { latitude, longitude } = @model.get('coordinates')
      title = formatLatLng(latitude, longitude)

    return title

  changeLocation: (e) ->
    Util.stop(e)

    trackUe(Noun.CARD_BACK, Verb.OPENS, 'location menu', '', '', 'by clicking the location overflow menu item', {
      idCard: @model.id
      idList: @model.getList().id
      idBoard: @model.getBoard().id
    })

    PopOver.pushView
      view: SetCardLocationPopoverView
      options: { @model, @modelCache, trackingMethod: 'by clicking on the location overflow menu item' }

  deleteLocation: (e) ->
    Util.stop(e)

    PopOver.pushView
      view: CardLocationDeleteView
      options: { @model, @modelCache }

  render: ->
    @$el.html template()

    @
